import SmallFence from "@components/Labels/SmallFence";
import { renderWithBranches } from "@ext/git/actions/Branch/BranchPanel/components/BranchCheckoutText";
import t from "@ext/localization/locale/translate";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogIcon,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";
import { CheckboxField } from "@ui-kit/Checkbox";
import { Loader } from "@ui-kit/Loader";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import { useLinkCheckout } from "../logic/useLinkCheckout";

const BranchElement = ({ branchName }: { branchName: string }) => (
	<div style={{ display: "inline-flex" }} title={branchName}>
		<SmallFence fixWidth overflow="hidden" value={branchName} />
	</div>
);

const CheckoutHandler = ({
	currentBranchName,
	branchToCheckout,
}: {
	currentBranchName: string;
	branchToCheckout: string;
}) => {
	const {
		isOpen,
		checkoutDialog,
		checkoutProcess,
		checkoutBlocked,
		transferChanges,
		hasLocalChanges,
		hideConfirmation,
		hideModeChoice,
		setHideModeChoice,
		cancel,
		onOpenChange,
		checkout,
	} = useLinkCheckout(branchToCheckout);

	return (
		<>
			{checkoutDialog}
			<AlertDialog onOpenChange={onOpenChange} open={isOpen}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogIcon icon="alert-circle" />
						<AlertDialogTitle>{t("git.checkout.change-branch")}?</AlertDialogTitle>
						<AlertDialogDescription className="article !bg-transparent">
							{checkoutProcess ? (
								<Loader size="lg" />
							) : (
								<>
									<p>{t("leads-to-the-branch")}</p>
									{transferChanges && hasLocalChanges && (
										<p>
											{renderWithBranches(t("git.checkout.transfer-description"), {
												from: currentBranchName,
												to: branchToCheckout,
											})}
										</p>
									)}
									<p>
										{t("git.checkout.change-branch")}{" "}
										<BranchElement branchName={currentBranchName} /> {t("to-branch").toLowerCase()}{" "}
										<BranchElement branchName={branchToCheckout} />{" "}
										{t("and-sync-catalog").toLowerCase()}
									</p>
								</>
							)}
						</AlertDialogDescription>
					</AlertDialogHeader>
					{!checkoutProcess && !hideConfirmation && (
						<CheckboxField
							checked={hideModeChoice}
							label={t("git.checkout.do-not-show-dialog-again")}
							onCheckedChange={(checked: boolean) => setHideModeChoice(checked)}
						/>
					)}
					{!checkoutProcess && (
						<AlertDialogFooter>
							<AlertDialogCancel onClick={cancel} variant="outline">
								{t("cancel")}
							</AlertDialogCancel>
							{checkoutBlocked ? (
								<Tooltip>
									<TooltipTrigger asChild>
										<span className="inline-flex">
											<AlertDialogAction disabled variant="primary">
												{t("change-and-sync")}
											</AlertDialogAction>
										</span>
									</TooltipTrigger>
									<TooltipContent>{t("git.checkout.enable-transfer-tooltip")}</TooltipContent>
								</Tooltip>
							) : (
								<AlertDialogAction
									onClick={(event) => {
										event.preventDefault();
										void checkout();
									}}
									variant="primary"
								>
									{t("change-and-sync")}
								</AlertDialogAction>
							)}
						</AlertDialogFooter>
					)}
				</AlertDialogContent>
			</AlertDialog>
		</>
	);
};

export default CheckoutHandler;
